// extracted by mini-css-extract-plugin
module.exports = {"empty":"styles_empty__1lKhI","empty__label":"styles_empty__label__3nrbe","empty__buttons":"styles_empty__buttons__2xdcd"};